import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { forkJoin } from "rxjs";
import { forEach } from 'lodash';

import { ShellDomainProvider } from "../utility/shell-domain.provider";
import { map } from "rxjs/operators";


@Injectable()
export class EcapCoreCalendarApiService {

    header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });

    constructor(private http: HttpClient) {
    }
    createReservationObject(payload): any {
        return this.http.post(ShellDomainProvider['api'].CalendarApiService + 'CalendarCommand/CreateReservationObject', payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    getReservationObjectById(reservationObejctId): any {
        return this.http.get(ShellDomainProvider['api'].CalendarApiService + "CalendarQuery/GetReservationObjectById?objectId=" + reservationObejctId,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    getReservationObjectsByIds(reservationObjectIds): any {
        let callList = [];
        forEach(reservationObjectIds, (reservationObjectId) => {
            let call = this.http.get(ShellDomainProvider['api'].CalendarApiService + "CalendarQuery/GetReservationObjectById?objectId=" + reservationObjectId,
                { headers: this.header, withCredentials: true, observe: 'response' });
            callList.push(call);
        });
        return forkJoin(callList).pipe(map(response=>response));
    }
    getReservationObjectsMergedAvailabilityWithSchedule(payload): any {
        return this.http.post(ShellDomainProvider['api'].CalendarApiService + 'CalendarQuery/GetReservationObjectsMergedAvailabilityWithSchedule', payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    getReservationObjectsMergedAvailabilityWithScheduleMultipleMonth(payload): any {
        let callList = [];
        forEach(payload, (payload) => {
            let call =this.http.post(ShellDomainProvider['api'].CalendarApiService + 'CalendarQuery/GetReservationObjectsMergedAvailabilityWithSchedule', payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
            callList.push(call);
        });
        return forkJoin(callList).pipe(map(response=>response));
    }
    createReservation(payload): any {
        return this.http.post(ShellDomainProvider['api'].CalendarApiService + 'CalendarCommand/CreateReservation', payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    deleteReservation(reservationId): any {
        let payload = {
            ReservationId: reservationId
        }
        return this.http.post(ShellDomainProvider['api'].CalendarApiService + 'CalendarCommand/DeleteReservation', payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    deleteMultipleReservation(reservationIds): any {
        let callList = [];
        forEach(reservationIds, (reservationId) => {
            let call = this.http.post(ShellDomainProvider['api'].CalendarApiService + 'CalendarCommand/DeleteReservation', { ReservationId: reservationId },
                { headers: this.header, withCredentials: true, observe: 'response' });
            callList.push(call);
        });
        return forkJoin(callList).pipe(map(response=>response));
    }
}
